<template>
  <a-card>
    <span slot="title">Sales Notification Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Sales Details" />
      <a-step title="Supporting documents" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import qs from "qs";
import Informasi from "./steps/Informasi.vue";
import DetailPenjualan from "./steps/DetailPenjualan.vue";
import DokumenPendukung from "./steps/DokumenPendukung.vue";
import Persetujuan from "./steps/Persetujuan.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "SalesNotificationCreate",
  props: ["id","sn_id","cust_id"],
  mixins: [GlobalMethod],
  components: {
    Informasi,
    DetailPenjualan,
    DokumenPendukung,
    Persetujuan,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "DetailPenjualan",
          content: "DetailPenjualan",
        },
        {
          title: "DokumenPendukung",
          content: "DokumenPendukung",
        },
        {
          title: "Persetujuan",
          content: "Persetujuan",
        },
      ],
      mode: "Create",
      collectData: {},
      listPenjualan: [],
      listCustomer: [],
      listAutoBidReasoning: [],
      listPipeline: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      listDokumen: [],
      dokumenPendukung: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    initialListItem() {
      let data = [];
      if (this.mode === "Edit") {
        this.listPenjualan.forEach((item) => {
          //hargaTotal = item.values.jumlah * item.values.harga;
          const values = item.values;
          data = [...data, { values }];
        });
      } else {
        data = this.listPenjualan;
        this.collectData.listBeli.forEach((item) => {
          data = [
            ...data,
            {
              values: item,
            },
          ];
        });
      }
      return data;
    },
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            mode: this.mode,
            listCustomer: this.listCustomer,
            listPipeline: this.listPipeline,
            listAutoBidReasoning: this.listAutoBidReasoning,
            sn_id: this.sn_id,
            cust_id: this.cust_id
          };
        } else if (this.steps[this.current].content === "DetailPenjualan") {
          return {
            listDokumen: this.listDokumen,
            listPenjualan: this.initialListItem,
            mode: "Edit",
          };
        } else if (this.steps[this.current].content === "DokumenPendukung") {
          return {
            listDokumen: this.listDokumen,
            informasi: this.collectData.informasi,
            mode: "Edit",
          };
        } else if (this.steps[this.current].content === "Persetujuan") {
          return {
            data: this.collectData.informasi,
            informasi: this.collectData.informasi,
            approval: this.collectData.approval,
            mode: this.mode,
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            dokumenPendukung: this.collectData.dokumenPendukung,
            mode: this.mode,
            listCustomer: this.listCustomer,
            listPipeline: this.listPipeline,
            listAutoBidReasoning: this.listAutoBidReasoning,
            sn_id: this.sn_id,
            cust_id: this.cust_id,
          };
        } else if (this.steps[this.current].content === "DetailPenjualan") {
          return {
            listDokumen: this.listDokumen,
            listPenjualan: this.listPenjualan,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "DokumenPendukung") {
          return {
            listDokumen: this.listDokumen,
            listPenjualan: this.listPenjualan,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "Persetujuan") {
          this.collectData.informasi.approval = JSON.parse(
            JSON.stringify(this.dokumenPendukung.approval)
          );
          return {
            data: this.collectData.informasi,
            informasi: this.collectData.informasi,
            mode: this.mode,
          };
        }
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "DetailPenjualan") {
        return "refDetailPenjualan";
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        return "refDokumenPendukung";
      } else if (this.steps[this.current].content === "Persetujuan") {
        return "refPersetujuan";
      }
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchDetail();
    }

    this.asyncAxiosGet(
            "sales_notification/product",
            this.getAuth,
            { 
              tlc: this.getAuth.username
            }
        ).then((response) => {
            this.listCustomer = response.list_customer;
            this.listPipeline = response.list_pipeline;
            this.listAutoBidReasoning = response.auto_bid_reasoning;
        }).catch((err) => {
            console.log(err);
        });
  },
  methods: {
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailPenjualan") {
        this.$refs.refDetailPenjualan.handleRef();
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        this.$refs.refDokumenPendukung.handleRef();
      }
    },
    prev() {
      // if (this.steps[this.current].content === "DokumenPendukung") {
      //   this.$refs.refDokumenPendukung.handleRefBack();
      // }
      this.current--;
    },
    validate() {
      this.$refs.refPersetujuan.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.mode === "Create") {
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
        } else {
          const catatan = this.collectData.informasi.catatan;
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
          this.collectData.informasi.catatan = catatan;
        }
        this.current++;
      } else if (this.steps[this.current].content === "DetailPenjualan") {
        // this.collectData.listPenjualan = JSON.parse(
        //   JSON.stringify(value.listPenjualan)
        // );
        this.current++;
      } else if (this.steps[this.current].content === "DokumenPendukung") {
        // if (this.collectData.length > 2) {
        //   this.collectData.push(JSON.parse(JSON.stringify(value)));
        // } else {
        //   this.dokumenPendukung = value;
        // }
        this.dokumenPendukung = value;

        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        this.collectData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    // valueFromChild2(value) {
    //   if (this.steps[this.current].content === "DokumenPendukung") {
    //     this.dokumenPendukung = value;
    //     this.current++;
    //   }
    // },
    getUpdateListPenjualan(item) {
      this.listPenjualan = item;
    },
    getListPenjualan(item) {
      this.listPenjualan = [
        ...this.listPenjualan,
        JSON.parse(JSON.stringify(item)),
      ];
      //ascending
      this.listPenjualan.sort(function (a, b) {
        return a.values.keyIndex - b.values.keyIndex;
      });
    },
    getUpdateDokumenrefBack(item) {
      this.listDokumen = item;
    },
    getUpdateDokumen(item) {
      //console.log(item);
      this.listDokumen.dokumenPendukung = item;
      //console.log("submit");

      // if (this.mode === "Edit") {
      //   this.confirmMessage("confirm-edit");
      // } else {
      //   this.confirmMessage("confirm-save");
      // }
    },
    setSubmitForm() {
      if (this.mode === "Edit") {
        this.postData.append("id_sales", this.id);
      }
      this.postData.append(
        "pipeline",
        this.collectData.informasi.pipeline
      );
      this.postData.append("tlc", this.getAuth.username);
      this.postData.append("tanggal", this.collectData.informasi.tanggal);
      //this.postData.append("project_nm", this.collectData.informasi.project_nm);
      this.postData.append("deskripsi", this.collectData.informasi.deskripsi);
      this.postData.append(
        "customer_id",
        this.collectData.informasi.customer_id
      );

      this.postData.append(
        "customer_nm",
        this.collectData.informasi.customer_nm
      );
      this.postData.append(
        "due_date_insp",
        this.collectData.informasi.due_date_insp
      );
      this.postData.append(
        "special_requirement",
        this.collectData.informasi.special_requirement == undefined
          ? ""
          : this.collectData.informasi.special_requirement
      );
      this.postData.append(
        "estimate_project_val",
        this.collectData.informasi.estimate_project_val == undefined
          ? "0"
          : Number(this.collectData.informasi.estimate_project_val)
      );
      this.postData.append(
        "estimate_project_cost",
        this.collectData.informasi.estimate_project_cost == undefined
          ? "0"
          : Number(this.collectData.informasi.estimate_project_cost)
      );
      this.postData.append(
        "prosentase_project_cost",
        this.collectData.informasi.prosentase_project_cost == undefined
          ? "0"
          : Number(this.collectData.informasi.prosentase_project_cost)
      );
      this.postData.append(
        "bid_reasoning",
        this.collectData.informasi.bid_reasoning == undefined
          ? ""
          : this.collectData.informasi.bid_reasoning
      );
      this.postData.append(
        "up_rfq_no",
        this.collectData.informasi.up_rfq_no == undefined
          ? ""
          : this.collectData.informasi.up_rfq_no
      );
      this.postData.append(
        "executor_site",
        this.collectData.informasi.executor_site == undefined
          ? ""
          : this.collectData.informasi.executor_site
      );

      this.postData.append(
        "catatan",
        this.collectData.persetujuan.catatan == undefined
          ? ""
          : this.collectData.persetujuan.catatan
      );
      let i = 0;
      this.listPenjualan.forEach((data) => {
        this.postData.append("nama_barang[" + i + "]", data.values.nama_barang);
        this.postData.append("pn_barang[" + i + "]", data.values.pn_barang);
        this.postData.append("note[" + i + "]", data.values.note);
        this.postData.append(
          "jumlah_barang[" + i + "]",
          data.values.jumlah_barang
        );
        this.postData.append("satuan[" + i + "]", data.values.satuan);
        i++;
      });

      if (this.listDokumen.dokumenPendukung) {
        i = 0;
        this.listDokumen.dokumenPendukung.forEach((data) => {
          if (!data.id_salesnotif_doc) {
            this.postData.append("nama_document[" + i + "]", data.file);
            this.postData.append(
              "deskripsi_doc[" + i + "]",
              data.deskripsi_doc
            );
            i++;
          }
        });

        i = 0;
        this.listDokumen.dokumenPendukung.forEach((data) => {
          if (data.id_salesnotif_doc) {
            this.postData.append("old_doc[" + i + "]", data.id_salesnotif_doc);
            i++;
          }
        });
      }

      if (this.mode === "Create") {
        i = 0;
        this.dokumenPendukung.approval.forEach((data) => {
          this.postData.append("tlc_actor[" + i + "]", data.tlc);
          this.postData.append("actor[" + i + "]", data.nama_bidang);
          if (data.nama_bidang == "Vice President Marketing") {
            i++;
            this.postData.append(
              "tlc_actor[" + i + "]",
              this.collectData.persetujuan.chif
            );
            this.postData.append(
              "actor[" + i + "]",
              "Chief Operation Officer / Site Manager"
            );
          }
          i++;
        });
      }
    },
    submit() {
      this.setSubmitForm();
      let method = "";
      let data;
      let url;
      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        url = "sales_notification/v2";
      } else {
        method = "post";
        data = this.postData;
        url = "sales_notification/editv2";
      }
      axios({
        method: method,
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
            // console.log(this.listDokumen.deleteExistingDoc);
            // console.log(this.listDokumen.deleteExistingDoc.length);
            // if (
            //   this.listDokumen.deleteExistingDoc !== undefined &&
            //   this.listDokumen.deleteExistingDoc.length >= 1
            // ) {
            //   //proses post delete file existing
            //   this.postUpdateDoc();
            // } else {
            //   this.displayMessage("success-edit");
            // }
          }
          this.current = 0;
          this.$router.go(-1);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    fetchDetail() {
      axios({
        method: "get",
        url: this.$serviceUrl + "sales_notification/revisi_salesnotif",
        params: {
          id_sales: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            //infoUmum: response.data.item_pp[0],
            //estimated_value: response.data.item_pp[0].estimated_value,
            informasi: response.data.header[0],
            dokumenPendukung: response.data.dokumen,
            listPenjualan: response.data.detil,
            approval: response.data.approval,
          };

          this.listDokumen = {
            informasi: response.data.header[0],
            dokumenPendukung: response.data.dokumen,
            //existing: response.data.dokumen,
            //deleteExistingDoc: [],
          };

          let keyforEach = 0;
          response.data.detil.forEach((item) => {
            this.listPenjualan = [
              ...this.listPenjualan,
              {
                values: {
                  keyIndex: keyforEach,
                  jumlah_barang: item.jumlah_barang,
                  nama_barang: item.nama_barang,
                  satuan: item.satuan,
                  pn_barang: item.pn_barang,
                  note: item.note,
                },
              },
            ];
            keyforEach++;
          });
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
        });
    },
    postUpdateDoc() {
      let longSize = this.listDokumen.deleteExistingDoc.length;
      let vLoop = 1;

      this.listDokumen.deleteExistingDoc.forEach((item) => {
        let urlEncodeValue = qs.stringify({
          id: item[0].id_salesnotif_doc,
        });

        axios({
          method: "delete",
          url: this.$serviceUrl + "sales_notification/document",
          processData: false,
          data: urlEncodeValue,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            if (vLoop === longSize) {
              this.displayMessage("success-edit");
            }
            vLoop++;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
          });
      });
    },
  },
  mounted() {
    //Event.$on("SalesNotifData2", this.valueFromChild2);
    Event.$on("SalesNotifData", this.valueFromChild);
    Event.$on("listPenjualan", this.getListPenjualan);
    Event.$on("updateDokumen", this.getUpdateDokumen);
    Event.$on("updateDokumenRefBack", this.getUpdateDokumenrefBack);
    Event.$on("UpdateListPenjualan", this.getUpdateListPenjualan);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    //Event.$on("SalesNotifData2", this.valueFromChild2);
    Event.$off("SalesNotifData", this.valueFromChild);
    Event.$off("listPenjualan", this.getListPenjualan);
    Event.$off("updateDokumen", this.getUpdateDokumen);
    Event.$off("updateDokumenRefBack", this.getUpdateDokumenrefBack);
    Event.$off("UpdateListPenjualan", this.getUpdateListPenjualan);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style></style>
